import React from "react";
import Modal from "react-responsive-modal";
import ModalHeader from "../ModalHeader";

const CustomModal = ({
  isOpen,
  onClose,
  title,
  children,
  className,
  noHeader = false,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      center
      showCloseIcon={false}
      classNames={{
        modal: `rounded-md min-w-[50%] w-[90%] sm:w-[100%] z-99999 outline-none`,
      }}
    >
      {!noHeader && <ModalHeader title={title} onClose={onClose} />}
      {children}
    </Modal>
  );
};

export default CustomModal;
